import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';
import React from 'react';

import type { TemplateClass } from '@feathr/blackbox';
import type { IUniversalSelectOption } from '@feathr/components';
import { templateTypeIcon } from '@feathr/extender/styles/template';

/* UniversalSelect calls this for both the menu rows and the selected value. */
export function formatTemplateTypeOptionLabel({ id, name }: IUniversalSelectOption): ReactNode {
  return (
    <>
      <FontAwesomeIcon icon={templateTypeIcon(id as TemplateClass)} /> {name}
    </>
  );
}
